// import React, { useState } from "react";

// import { useDispatch, useSelector } from "react-redux";
// import { Pre_Loading, Show_Message } from "../General/Messagedialogbox";
// import {
//   Select_AttProduct,
//   Select_BatchProduct,
//   Select_Product,
//   ShowHide_Popup,
// } from "../features/Transactionstates";
// import { useEffect } from "react";
// import { API_FETCH, API_POST } from "../General/Utility";
// import PopupSearch from "./PopupSearch";

// function TransProductSearch(props) {
//   const dispatch = useDispatch();

//   const _Common = useSelector((store) => store.Transstates.Common);
//   const _HT = useSelector((store) => store.Transstates.Header);
//   const _DT = useSelector((store) => store.Transstates.Data);
//   const _AuthParems = useSelector((state) => state.Common.Admin);
//   const [arrProduct, setarrProduct] = useState([]);
//   const [arrEntWH, setarrEntWH] = useState([]);
//   const [iWHId, setiWHId] = useState(0);
//   const [arrEntTableCol, setarrEntTableCol] = useState([]);
//   const [strSearch, setstrSearch] = useState("");

//   useEffect(() => {
//     Load_StockbyProduct();
//   }, []);
//   const Load_StockbyProduct = async () => {
//     try {
//       await Pre_Loading(dispatch, true);
//       const parems = {
//         iScrId: _Common.iScrId,
//         ScrType: _Common.strScrType,
//         iPartyId: _HT.iPartyId,
//         iTaxRelId: _HT.iTaxRelId,
//         strSearch: "",
//         iWHId: props.WHId ? props.WHId : iWHId,
//         iBranchId: _AuthParems.Branch,
//         iUserId: Number(_AuthParems.User),
//         iRoleId: Number(_AuthParems.Role),
//         iClientId: Number(_AuthParems.Client),
//         strDBName: _AuthParems.DB,
//       };
//       setiWHId(parems.iWHId);
//       console.log("Load_StockbyProduct Payload", parems);

//       const res = await API_POST(
//         `ProductTrans/Load_StockbyProduct/`,
//         parems,
//         dispatch
//       );
//       if (res) {
//         setarrEntTableCol(res.EntTablDesign);
//         setarrProduct(res.EntProduct);
//         setarrEntWH(res.EntWH);
//         setiWHId(res.iWHId);
//       }
//     } catch (e) {
//       Show_Message(dispatch, e.message, "error");
//     } finally {
//       await Pre_Loading(dispatch, false);
//     }
//   };
//   const Warehouse_OnChange = async (WHId) => {
//     try {
//       await Pre_Loading(dispatch, true);
//       setiWHId(WHId);
//       const parems = {
//         iScrId: _Common.iScrId,
//         ScrType: _Common.strScrType,
//         iPartyId: _HT.iPartyId,
//         TaxRelId: _HT.iTaxRelId,
//         strSearch: strSearch,
//         iWHId: WHId,
//         iBranchId: _AuthParems.Branch,
//         iUserId: Number(_AuthParems.User),
//         iRoleId: Number(_AuthParems.Role),
//         iClientId: Number(_AuthParems.Client),
//         strDBName: _AuthParems.DB,
//       };
//       const res = await API_POST(
//         `ProductTrans/Search_StockbyProduct/`,
//         parems,
//         dispatch
//       );
//       if (res) {
//         setarrProduct(res.EntProduct);
//       }
//     } catch (e) {
//       Show_Message(dispatch, e.message, "error");
//     } finally {
//       await Pre_Loading(dispatch, false);
//     }
//   };
//   // const Search_Product = async (strtxt) => {



//   // ✅ make sure this exists

//   const Search_Product = async (strtxt) => {
//     try {
//       await Pre_Loading(dispatch, true);
//       setstrSearch(strtxt);
//       const parems = {
//         iScrId: _Common.iScrId,
//         ScrType: _Common.strScrType,
//         iPartyId: _HT.iPartyId,
//         iTaxRelId: _HT.iTaxRelId,
//         strSearch: strtxt,
//         iWHId: iWHId,
//         iBranchId: _AuthParems.Branch,
//         iUserId: Number(_AuthParems.User),
//         iRoleId: Number(_AuthParems.Role),
//         iClientId: Number(_AuthParems.Client),
//         strDBName: _AuthParems.DB,
//       };
//       const res = await API_POST(`ProductTrans/Search_StockbyProduct/`, parems, dispatch);
//       if (res) {
//         const currentDT = _DT.arrEntDT ?? [];

//         // ✅ Overlay current invoice qty into search results
//         const merged = res.EntProduct.map((pro) => {
//           const match = currentDT.find((dt) => dt.ProId === pro.iProId);
//           return {
//             ...pro,
//             Qty: match ? Number(match.Qty) : 0,  // already added in current invoice
//           };
//         });

//         setarrProduct(merged);
//       }
//     } catch (e) {
//       Show_Message(dispatch, e.message, "error");
//     } finally {
//       await Pre_Loading(dispatch, false);
//     }
//   };
//   //   try {
//   //     await Pre_Loading(dispatch, true);
//   //     setstrSearch(strtxt);
//   //     const parems = {
//   //       iScrId: _Common.iScrId,
//   //       ScrType: _Common.strScrType,
//   //       iPartyId: _HT.iPartyId,
//   //       iTaxRelId: _HT.iTaxRelId,   // renamed
//   //       strSearch: strtxt,          // use the fresh text
//   //       iWHId: iWHId,
//   //       iBranchId: _AuthParems.Branch,
//   //       iUserId: Number(_AuthParems.User),
//   //       iRoleId: Number(_AuthParems.Role),
//   //       iClientId: Number(_AuthParems.Client),
//   //       strDBName: _AuthParems.DB,
//   //       objBaseTransDT: _DT.arrEntDT ?? [],
//   //     };
//   //     const res = await API_POST(`ProductTrans/Search_StockbyProduct/`, parems, dispatch);
//   //     if (res) setarrProduct(res.EntProduct);
//   //   } catch (e) {
//   //     Show_Message(dispatch, e.message, "error");
//   //   } finally {
//   //     await Pre_Loading(dispatch, false);
//   //   }
//   // };
//   const View_Product = async (Product) => {
//     console.log("Full Product object:", Product);
//     try {
//       await Pre_Loading(dispatch, true);

//       if (_Common.iScrId === 0) {
//         const res = await API_FETCH(
//           `ProductMaster/View_Product/${Product.iProId}/${Product.iAttGrpId}/${_AuthParems.Branch}/${_AuthParems.DB}`,
//           dispatch
//         );
//         if (res) {
//           await props.OnSelectProduct(res);
//           await Popup_Close();
//         }
//         return;
//       }

//       const objTrans = {
//         iScrId: _Common.iScrId,
//         ScrType: _Common.strScrType,
//         strScrType: _Common.strScrType,
//         iPartyId: _HT.iPartyId,
//         iTaxRelId: _HT.iTaxRelId,
//         Search: strSearch || "",
//         iWHId: props.WHId ? props.WHId : iWHId,
//         iBranchId: _AuthParems.Branch,
//         strDBName: _AuthParems.DB,
//         iProId: Product.iProId,
//         isComposPro: Product.isComposPro ?? Product.isCompos ?? 0,
//         isBatchPro: Product.isBatchPro,
//         isAttPro: Product.isAttPro,
//         iAttGrpId: Product.iAttGrpId,
//         TransType: "Transaction",
//       };

//       if (!Product.iProId) {
//         console.error("View_Product Error: Product object missing iProId", Product);
//         Show_Message(dispatch, "Selected Product has no ID", "error");
//         await Pre_Loading(dispatch, false);
//         return;
//       }

//       if (Product.isAttPro === 1) {
//         Product.WHId = iWHId;
//         await dispatch(Select_AttProduct(Product));
//         await dispatch(ShowHide_Popup("IsAttPro"));
//       } else {
//         console.log("View_Product Full Payload:", objTrans);
//         console.log("View_Product Input Product:", Product);

//         const res = await API_POST(`ProductTrans/View_Product/`, objTrans, dispatch);

//         if (!res) {
//           console.error("View_Product: API response is undefined or null");
//           return;
//         }

//         if (res.EntProduct && res.EntProduct.length > 0) {
//           res.ProInfo = res.EntProduct;
//           res.ProUnit = res.EntUOM;
//           res.WHId = iWHId;

//           if (Product.isBatchPro === 1 && _Common.iScrId !== 37) {
//             // ✅ OpenStock (37) la batch popup வேண்டாம்
//             await dispatch(Select_BatchProduct(res));
//             await dispatch(ShowHide_Popup("IsBatchPro"));
//           } else {
//             await Popup_Close();
//             if (_Common.IsPOS) await props.Add_NewProduct(res);
//             else await dispatch(Select_Product(res));
//           }
//         } else {
//           console.error("View_Product: Entry Product missing or empty in response", res);
//           Show_Message(dispatch, "Product Details Not Found", "error");
//         }
//       }
//     } catch (err) {
//       Show_Message(dispatch, err.message, "error");
//     } finally {
//       await Pre_Loading(dispatch, false);
//     }
//   };


//   // const View_Product = async (Product) => {
//   //   try {
//   //     await Pre_Loading(dispatch, true);
//   //     const objTrans = {
//   //       iScrId: _Common.iScrId,
//   //       ScrType: _Common.strScrType,
//   //       iPartyId: _HT.iPartyId,
//   //       iTaxRelId: _HT.iTaxRelId,
//   //       Search: "strSearch",
//   //       iWHId: props.WHId ? props.WHId : iWHId,
//   //       iBranchId: _AuthParems.Branch,
//   //       strDBName: _AuthParems.DB,
//   //       iProId: Product.iProId,
//   //       isComposPro: Product.isComposPro,
//   //       isBatchPro: Product.isBatchPro,
//   //       isAttPro: Product.isAttPro,
//   //       iAttGrpId: Product.iAttGrpId,
//   //       TransType: "Transaction",
//   //     };
//   //     if (Product.isAttPro === 1) {
//   //       Product.WHId = iWHId;
//   //       await dispatch(Select_AttProduct(Product));
//   //       await dispatch(ShowHide_Popup("IsAttPro"));
//   //     } else {
//   //       const res = await API_POST(
//   //         `ProductTrans/View_Product/`,
//   //         objTrans,
//   //         dispatch
//   //       );
//   //       console.log(res);
//   //       if (res) {
//   //         res.WHId = iWHId;
//   //         if (Product.isAttPro === 0 && Product.isBatchPro === 1) {
//   //           await dispatch(Select_BatchProduct(res));
//   //           await dispatch(ShowHide_Popup("IsBatchPro"));
//   //         } else {
//   //           await Popup_Close();
//   //           if (props.View_Product) await props.View_Product(res);
//   //           else await dispatch(Select_Product(res));
//   //         }
//   //       }
//   //     }
//   //   } catch (err) {
//   //     Show_Message(dispatch, err.message, "error");
//   //   } finally {
//   //     await Pre_Loading(dispatch, false);
//   //   }
//   // };
//   const Popup_Close = async () => {
//     await dispatch(ShowHide_Popup("IsProSearch"));
//   };
//   return (
//     <PopupSearch
//       ScrName="PRODUCT SEARCH "
//       FilterCol={[]}
//       FilterVal={""}
//       FilterShow={false}
//       strSearch={strSearch}
//       Columns={arrEntTableCol}
//       Data={arrProduct}
//       Warehouse={arrEntWH}
//       WHId={iWHId}
//       Wharehouse_Onchange={(val) => Warehouse_OnChange(val)}
//       IsWareHouse={_Common.IsMultiWarehouse}
//       UpdateFilterCol={""}
//       Search_Data={(e) => Search_Product(e)}
//       View_Data={(e) => View_Product(e)}
//       Close={() => Popup_Close()}
//       disableWH={props.WHId ? true : false}
//     />
//   );
// }
// export default TransProductSearch;







import React, { useState, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { Pre_Loading, Show_Message } from "../General/Messagedialogbox";
import {
  Select_AttProduct,
  Select_BatchProduct,
  Select_Product,
  ShowHide_Popup,
} from "../features/Transactionstates";
import { API_FETCH, API_POST } from "../General/Utility";
import PopupSearch from "./PopupSearch";

function TransProductSearch(props) {
  const dispatch = useDispatch();

  const _Common    = useSelector((store) => store.Transstates.Common);
  const _HT        = useSelector((store) => store.Transstates.Header);
  const _AuthParems = useSelector((state) => state.Common.Admin);

  const [arrProduct,    setarrProduct]    = useState([]);
  const [arrEntWH,      setarrEntWH]      = useState([]);
  const [iWHId,         setiWHId]         = useState(0);
  const [arrEntTableCol,setarrEntTableCol]= useState([]);
  const [strSearch,     setstrSearch]     = useState("");

  useEffect(() => {
    Load_StockbyProduct();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ─── Helper: overlay "already added" qty from OpenStock list ──────────────
  // props.addedProducts — passed from OpenStock screen only (iScrId 37)
  // For all other screens, _DT.arrEntDT is used via normal transaction flow
  const Overlay_AddedQty = (entProduct) => {
    const addedList = props.addedProducts ?? [];
    if (addedList.length === 0) return entProduct;
    return entProduct.map((pro) => {
      const match = addedList.find((p) => p.proId === pro.iProId);
      return { ...pro, dAddedQty: match ? Number(match.qty) : 0 };
    });
  };

  // ─── Load initial product list ─────────────────────────────────────────────
  const Load_StockbyProduct = async () => {
    try {
      await Pre_Loading(dispatch, true);
      const parems = {
        iScrId:    _Common.iScrId,
        ScrType:   _Common.strScrType,
        iPartyId:  _HT.iPartyId,
        iTaxRelId: _HT.iTaxRelId,
        strSearch: "",
        iWHId:     props.WHId ? props.WHId : iWHId,
        iBranchId: _AuthParems.Branch,
        iUserId:   Number(_AuthParems.User),
        iRoleId:   Number(_AuthParems.Role),
        iClientId: Number(_AuthParems.Client),
        strDBName: _AuthParems.DB,
      };
      setiWHId(parems.iWHId);
      const res = await API_POST(`ProductTrans/Load_StockbyProduct/`, parems, dispatch);
      if (res) {
        setarrEntTableCol(res.EntTablDesign);
        setarrProduct(Overlay_AddedQty(res.EntProduct));
        setarrEntWH(res.EntWH);
        setiWHId(res.iWHId);
      }
    } catch (e) {
      Show_Message(dispatch, e.message, "error");
    } finally {
      await Pre_Loading(dispatch, false);
    }
  };

  // ─── Warehouse change ──────────────────────────────────────────────────────
  // FIX: was TaxRelId → corrected to iTaxRelId
  const Warehouse_OnChange = async (WHId) => {
    try {
      await Pre_Loading(dispatch, true);
      setiWHId(WHId);
      const parems = {
        iScrId:    _Common.iScrId,
        ScrType:   _Common.strScrType,
        iPartyId:  _HT.iPartyId,
        iTaxRelId: _HT.iTaxRelId,
        strSearch: strSearch,
        iWHId:     WHId,
        iBranchId: _AuthParems.Branch,
        iUserId:   Number(_AuthParems.User),
        iRoleId:   Number(_AuthParems.Role),
        iClientId: Number(_AuthParems.Client),
        strDBName: _AuthParems.DB,
      };
      const res = await API_POST(`ProductTrans/Search_StockbyProduct/`, parems, dispatch);
      if (res) setarrProduct(Overlay_AddedQty(res.EntProduct));
    } catch (e) {
      Show_Message(dispatch, e.message, "error");
    } finally {
      await Pre_Loading(dispatch, false);
    }
  };

  // ─── Search ────────────────────────────────────────────────────────────────
  const Search_Product = async (strtxt) => {
    try {
      await Pre_Loading(dispatch, true);
      setstrSearch(strtxt);
      const parems = {
        iScrId:    _Common.iScrId,
        ScrType:   _Common.strScrType,
        iPartyId:  _HT.iPartyId,
        iTaxRelId: _HT.iTaxRelId,
        strSearch: strtxt,
        iWHId:     iWHId,
        iBranchId: _AuthParems.Branch,
        iUserId:   Number(_AuthParems.User),
        iRoleId:   Number(_AuthParems.Role),
        iClientId: Number(_AuthParems.Client),
        strDBName: _AuthParems.DB,
      };
      const res = await API_POST(`ProductTrans/Search_StockbyProduct/`, parems, dispatch);
      if (res) setarrProduct(Overlay_AddedQty(res.EntProduct));
    } catch (e) {
      Show_Message(dispatch, e.message, "error");
    } finally {
      await Pre_Loading(dispatch, false);
    }
  };

  // ─── Product select ────────────────────────────────────────────────────────
  const View_Product = async (Product) => {
    try {
      await Pre_Loading(dispatch, true);

      // ProductMaster screen (iScrId = 0) — different flow
      if (_Common.iScrId === 0) {
        const res = await API_FETCH(
          `ProductMaster/View_Product/${Product.iProId}/${Product.iAttGrpId}/${_AuthParems.Branch}/${_AuthParems.DB}`,
          dispatch
        );
        if (res) {
          await props.OnSelectProduct(res);
          await Popup_Close();
        }
        return;
      }

      if (!Product.iProId) {
        Show_Message(dispatch, "Selected product has no ID", "error");
        return;
      }

      const objTrans = {
        iScrId:      _Common.iScrId,
        ScrType:     _Common.strScrType,
        strScrType:  _Common.strScrType,
        iPartyId:    _HT.iPartyId,
        iTaxRelId:   _HT.iTaxRelId,
        Search:      strSearch || "",
        iWHId:       props.WHId ? props.WHId : iWHId,
        iBranchId:   _AuthParems.Branch,
        strDBName:   _AuthParems.DB,
        iProId:      Product.iProId,
        isComposPro: Product.isComposPro ?? Product.isCompos ?? 0,
        isBatchPro:  Product.isBatchPro,
        isAttPro:    Product.isAttPro,
        iAttGrpId:   Product.iAttGrpId,
        TransType:   "Transaction",
      };

      if (Product.isAttPro === 1) {
        Product.WHId = iWHId;
        await dispatch(Select_AttProduct(Product));
        await dispatch(ShowHide_Popup("IsAttPro"));
      } else {
        const res = await API_POST(`ProductTrans/View_Product/`, objTrans, dispatch);

        if (!res) {
          Show_Message(dispatch, "Product details fetch failed", "error");
          return;
        }

        if (res.EntProduct && res.EntProduct.length > 0) {
          res.ProInfo = res.EntProduct;
          res.ProUnit = res.EntUOM || [];
          res.WHId    = iWHId;

          // iScrId 37 = OpenStock — batch popup skip pannanum
          if (Product.isBatchPro === 1 && _Common.iScrId !== 37) {
            await dispatch(Select_BatchProduct(res));
            await dispatch(ShowHide_Popup("IsBatchPro"));
          } else {
            await Popup_Close();
            if (_Common.IsPOS) await props.Add_NewProduct(res);
            else await dispatch(Select_Product(res));
          }
        } else {
          Show_Message(dispatch, "Product details not found", "error");
        }
      }
    } catch (err) {
      Show_Message(dispatch, err.message, "error");
    } finally {
      await Pre_Loading(dispatch, false);
    }
  };

  // ─── Close popup ───────────────────────────────────────────────────────────
  const Popup_Close = async () => {
    await dispatch(ShowHide_Popup("IsProSearch"));
  };

  return (
    <PopupSearch
      ScrName="PRODUCT SEARCH"
      FilterCol={[]}
      FilterVal={""}
      FilterShow={false}
      strSearch={strSearch}
      Columns={arrEntTableCol}
      Data={arrProduct}
      Warehouse={arrEntWH}
      WHId={iWHId}
      Wharehouse_Onchange={(val) => Warehouse_OnChange(val)}
      IsWareHouse={_Common.IsMultiWarehouse}
      UpdateFilterCol={""}
      Search_Data={(e) => Search_Product(e)}
      View_Data={(e) => View_Product(e)}
      Close={() => Popup_Close()}
      disableWH={props.WHId ? true : false}
    />
  );
}

export default TransProductSearch;